<button class="theme_btn" type="button" (click)="onClickToggleClass()">
    <i [ngClass]="theme !== 'dark' ? 'bi bi-sun-fill': 'bi bi-moon-fill'"></i>
    <!-- {{theme}} -->
    <!-- {{activeTheme}} -->
    <!-- <i class="bi bi-moon-fill"></i> -->
</button>